import { useEffect, useState } from "react";
import config from "../config/environment";
import { getRealtimeConfig } from "../services/whatsapp/whatsappService";
import { handleApi } from "../utils/handleApi";

let cachedRealtimeEnvironment: string | null = null;
let pendingRealtimeEnvironment: Promise<string> | null = null;

const resolveRealtimeEnvironment = async () => {
  if (cachedRealtimeEnvironment) return cachedRealtimeEnvironment;
  if (pendingRealtimeEnvironment) return pendingRealtimeEnvironment;

  pendingRealtimeEnvironment = handleApi(getRealtimeConfig(), false).then(({ res }) => {
    const environment =
      res?.firebase_prefix ||
      res?.env ||
      config.environment ||
      "development";
    cachedRealtimeEnvironment = environment;
    pendingRealtimeEnvironment = null;
    return environment;
  });

  return pendingRealtimeEnvironment;
};

export const useRealtimeEnvironment = () => {
  const [environment, setEnvironment] = useState(cachedRealtimeEnvironment);

  useEffect(() => {
    let cancelled = false;
    resolveRealtimeEnvironment().then((resolved) => {
      if (!cancelled) {
        setEnvironment(resolved);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return environment;
};
